import * as React from "react";
function SvgIcChevronDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.703 10l6.67 3.85L19.04 10l.375.649-7.044 4.067-7.044-4.067.375-.649z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChevronDown;
